import { convertToFormattedId } from "@graffer-inc/cloud-gov-core";
import { GetInvoiceBusinessIssuersByOrgIdQuery } from "../../../../../graphql/generated/types";
import { SecondaryButton } from "@graffer-inc/console-design-kit";

type Props = {
  businessIssuers: GetInvoiceBusinessIssuersByOrgIdQuery["invoiceBusinessIssuersByOrgID"];
  handleOnEdit: (id: string) => void;
};

export const QualifiedInvoiceBusinessIssuersTable: React.FC<Props> = ({
  businessIssuers,
  handleOnEdit,
}) => {
  return (
    <table className="table is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>登録事業者名</th>
          <th>登録番号</th>
          <th>交付可能なグループ</th>
          <th aria-label="編集"></th>
        </tr>
      </thead>
      <tbody>
        {businessIssuers.map(({ id, name, registrationNumber, groups }) => {
          return (
            <tr key={id} className="c-tr-has-tag">
              <td>
                <div className="c-word-break-all">
                  {convertToFormattedId(id)}
                </div>
              </td>
              <td>
                <div className="c-word-break-all">{name}</div>
              </td>
              <td>
                <div className="c-word-break-all">{registrationNumber}</div>
              </td>
              <td>
                {!!groups.length && (
                  <ul className="c-word-break-all">
                    {groups.map((g, i) => {
                      return <li key={`${g?.id}-${i}`}>{g?.name}</li>;
                    })}
                  </ul>
                )}
              </td>
              <td>
                <div className="is-flex is-align-items-center">
                  <SecondaryButton
                    text="編集"
                    onClick={() => handleOnEdit(id)}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
